import { useState } from 'react';
import { TabsBar } from '../../../../components';
import { Box, Tab, Tabs } from '@mui/material';
import { ExecutedContracts } from './ExecutedContracts';
import { PendingContracts } from './PendingContracts';

export const ContractActivityDetails = () => {
  const [selectedTab, setSelectedTab] = useState<number>(0);
  return (
    <Box mt={-1} position="relative">
      <TabsBar>
        <Tabs
          value={selectedTab}
          indicatorColor="primary"
          textColor="primary"
          onChange={(_, value) => {
            setSelectedTab(value);
          }}
        >
          <Tab id="executed" aria-controls="executed" label="Executed Contracts" />
          <Tab id="pending" aria-controls="pending" label="Pending Contracts" />
        </Tabs>
      </TabsBar>
      {selectedTab === 0 && <ExecutedContracts />}
      {selectedTab === 1 && <PendingContracts />}
    </Box>
  );
};
